import { createRoute } from '@tanstack/react-router'

import { SharePanel } from '../../collections/share-panel.js'
import { TreeManager } from '../../collections/tree-manager.js'
import { settingsRoute } from './layout.js'

export const settingsCollectionsRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'collections',
  component: () => (
    <TreeManager
      kind="collections"
      details={(node) => <SharePanel key={node.id} collectionId={node.id} name={node.name} />}
    />
  ),
})
